import { render, staticRenderFns } from "./Ending.vue?vue&type=template&id=bb607eb8&scoped=true&lang=pug&"
import script from "./Ending.vue?vue&type=script&lang=js&"
export * from "./Ending.vue?vue&type=script&lang=js&"
import style0 from "./Ending.vue?vue&type=style&index=0&id=bb607eb8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb607eb8",
  null
  
)

export default component.exports